module.exports = ".nav-bar-shadow{width:100%;padding-top:10.6280193237vw;height:10.6280193237vw;box-sizing:content-box}.nav-bar-shadow.notInApp{padding-top:0}"